/**
 * useOccupationExport Hook
 * Custom hook for exporting occupations to Excel
 */

import { useState, useCallback } from 'react';
import { occupationService, OccupationFilters } from '../services/occupationService';
import { useSnackbar } from 'notistack';

interface UseOccupationExportResult {
  exporting: boolean;
  exportOccupations: (filters?: Partial<OccupationFilters>, filename?: string) => Promise<void>;
}

export const useOccupationExport = (): UseOccupationExportResult => {
  const { enqueueSnackbar } = useSnackbar();

  const [exporting, setExporting] = useState<boolean>(false);

  const exportOccupations = useCallback(async (
    filters?: Partial<OccupationFilters>,
    filename = 'cargos.xlsx'
  ): Promise<void> => {
    try {
      setExporting(true);

      const blob = await occupationService.exportOccupations(filters);

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      enqueueSnackbar('Ocupações exportadas com sucesso', { variant: 'success' });
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Erro ao exportar ocupações';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      setExporting(false);
    }
  }, [enqueueSnackbar]);

  return {
    exporting,
    exportOccupations
  };
};
